/**
 * X Switcher
 */

const xSwitcher = document.querySelector('#x-switcher');
const xSwitcherBodyOverlay = document.querySelector('.x-switcher__body-overlay');

if (xSwitcher) {
  const xSwitcherButton = xSwitcher.querySelector('.x-switcher__button');
  const xSwitcherOverlay = xSwitcher.querySelector('.x-switcher__overlay');

  xSwitcherButton.addEventListener('click', (e) => {
    e.preventDefault();
    const site = document.querySelector('.js-page');
    xSwitcherOverlay.setAttribute('aria-expanded', true);
    site.classList.add('blur-out');

    setTimeout(() => {
      document.location.href = xSwitcherButton.href;
    }, 1000);
  });

  window.addEventListener('DOMContentLoaded', () => {
    if (xSwitcherBodyOverlay) {
      const site = document.querySelector('.js-page');

      xSwitcherBodyOverlay.setAttribute('aria-expanded', false);
      site.classList.add('blur-in');
    }
  });

  var headroom = new Headroom(xSwitcher, {
    offset: 0,
    tolerance: 25,
    classes: {
      initial: "animated",
      pinned: "slideDown",
      unpinned: "slideUp"
    }
  });

  headroom.init();

}


